import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { ProgramListScene } from 'scenes';

class ProgramListContainer extends AbstractContainer {

  getTasks(params) {

    return [
      {
        key: 'programs',
        exec: (done, failure) => {
          API.get(`programs`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ProgramListScene {...results} />
  }
}

export default ProgramListContainer;
